import { jsx as e } from "react/jsx-runtime";
import { TextSkeleton as o } from "../../../components/TextSkeleton/index.js";
import { DealStampContainer as i } from "./style.js";
function p({
  animate: t,
  width: r,
  className: n
}) {
  return /* @__PURE__ */ e(i, { $inactive: !1, className: n, children: /* @__PURE__ */ e("span", { children: /* @__PURE__ */ e(o, { animate: t, width: r }) }) });
}
export {
  p as DealStampSkeleton
};
